module.exports = __webpack_public_path__ + "media/images/scribe-unlisted-small-26b6631a.png";